/**
 * jquery.maskedinput
 * This is a masked input plugin for the jQuery javascript library.
 * It allows a user to more easily enter fixed width input
 * where you would like them to enter the data in a certain format (dates,phone numbers, etc).
 *
 * https://www.npmjs.com/package/jquery.maskedinput
 *
 * @package Monapix
 * @version 3.0.1
 * @author Binary Cats Inc.
 */

require ('jquery.maskedinput')



// WEBPACK FOOTER //
// ./resources/js/services/jquery/mask.js